import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/legacy/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();

// Resolve pdf.js asset prefixes relative to the served document, not the bucket
// root. Served from `…/branches/<b>/taskpane.html`, a root-absolute `/pdfjs/…`
// would resolve to the bucket root and silently load staging's assets; the
// document-relative base keeps a per-branch build pointed at its own copies.
// At the root deployment (`…/taskpane.html`) the base is `…/`, so this is
// byte-compatible with the previous `/pdfjs/…` behavior.
const PDF_ASSET_BASE = (() => {
  try {
    if (typeof document !== "undefined" && document.baseURI) {
      return new URL("./", document.baseURI).href;
    }
  } catch {
    // Fall through to the root-absolute default below.
  }
  return "/";
})();

// Without these, pdf.js silently degrades: JPEG2000 images render blank, CJK glyphs fall back to
// boxes, standard-font fallbacks don't kick in. Trailing slash matters — pdf.js appends file names.
export const PDF_JS_OPTIONS = {
  cMapUrl: PDF_ASSET_BASE + "pdfjs/cmaps/",
  cMapPacked: true,
  standardFontDataUrl: PDF_ASSET_BASE + "pdfjs/standard_fonts/",
  wasmUrl: PDF_ASSET_BASE + "pdfjs/wasm/",
  iccUrl: PDF_ASSET_BASE + "pdfjs/iccs/",
} as const;
